export const SmileIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      {...props}
    >
      <circle cx="10.0002" cy="9.99992" r="9.16667" />
      <path d="M14.1668 10.8333C14.1668 13.1344 12.3013 14.9999 10.0002 14.9999C7.69898 14.9999 5.8335 13.1344 5.8335 10.8333" />
      <path d="M5.8335 10.8333H14.1668" />
      <path d="M7.5 7.5L7.5 6.66667" />
      <path d="M12.5 7.5L12.5 6.66667" />
    </svg>
  );
};
